import styled from 'styled-components';

import { Media } from '../../theme';

export const Container = styled.div`
  height: 700px;
  max-width: 100%;
  display: flex;
  ${Media.tablet`
    flex-direction: column;
    height: auto;
  `}
`;

export const PhotoColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  ${Media.tablet`
    width: 100%;
  `}
`;

export const VideoPlayerContainer = styled.div`
  width: calc(40% - 10px);
  height: 100%;
  margin: 0 5px;
  ${Media.tablet`
    height: 330px;
    width: 100%;
    margin: 5px 0;
  `}
`;
